export default {
  'Category.FieldsWrapper.Delete': ({ }, outlet) => {
    outlet({ action: 'delete' })
  },
  'Category.FieldsWrapper.AmountWrapper.Amount': ({ value, category }, outlet, internalStateSetter) => {
    let floatValues = new RegExp(/^[0-9]*[.]?[0-9]*$/, 'i');
    if (floatValues.test(value)) {
      internalStateSetter({ localValue: value })
      outlet({ category: { ...category, amount: parseFloat(value) }, action: 'edit' })
    }
  },
  'Category.FieldsWrapper.CategoryWrapper.Dropdown': ({ category, selectedOptionIds }, outlet) => {
    outlet({ category: { ...category, category_id: selectedOptionIds[0] }, action: 'edit' })
  },
  'Category.Budget': () => { }
}
